// @flow

export const EDIT_PRODUCT = 'EDIT_PRODUCT';

export const ADD_PRODUCT = 'ADD_PRODUCT';
export const SAVE_PRODUCT = 'SAVE_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';

export const defaultProduct = {
  id: '',
  name: '',
  rate: '',
  taxable: 0,
  salesTax: '',
  published: true,
  trash: false,
  organizationId: ''
};
